// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"dd-z","landingPageVideo":"ed-z","play":"fd-z","iframeVideo":"gd-z","playHidden":"hd-z","fullwidth":"id-z"};